import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ModelState = {
  isRunningModelOutput: boolean | null;
  duration: number | null;
  updateIsRunningModelOutput: (isRunning: boolean | null) => void;
  updateDuration: (duration: number | null) => void;
};

const useModelStore = create<ModelState>()(
  devtools(
    (set) => ({
      isRunningModelOutput: null,
      duration: null,
      updateDuration: (duration) => set(() => ({ duration })),
      updateIsRunningModelOutput: (isRunningModelOutput) =>
        set(() => ({ isRunningModelOutput })),
    }),
    { name: 'modelStore' }
  )
);

export const useModelState = () =>
  useModelStore((state) => ({
    isRunningModelOutput: state.isRunningModelOutput,
  }));

export const useModelActions = () =>
  useModelStore((state) => ({
    updateIsRunningModelOutput: state.updateIsRunningModelOutput,
  }));

export default useModelStore;
